export default __webpack_public_path__ + "static/media/paiementPro-min.cfad907b.webp";